var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99668 1.33333C4.29974 1.33333 1.29932 4.32 1.29932 8C1.29932 11.68 4.29974 14.6667 7.99668 14.6667C11.6936 14.6667 14.694 11.68 14.694 8C14.694 4.32 11.6936 1.33333 7.99668 1.33333ZM2.63879 8C2.63879 5.05333 5.03645 2.66667 7.99668 2.66667C9.23569 2.66667 10.3742 3.08667 11.2784 3.79333L3.77064 11.2667C3.06072 10.3667 2.63879 9.23333 2.63879 8ZM4.71497 12.2067C5.61912 12.9133 6.75767 13.3333 7.99668 13.3333C10.9569 13.3333 13.3546 10.9467 13.3546 8C13.3546 6.76667 12.9326 5.63333 12.2227 4.73333L4.71497 12.2067Z",
    fill: "#C3C9D3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.9f681be685b1cf479880fbe28b5d01ac.svg";
export { ForwardRef as ReactComponent };